export const DEFAULT_LANGUAGE = 'en';
export default {
  EXPORT: {
    en: 'Export',
    fi: 'Vie',
  },
  FULL_SCREEN: {
    en: 'Full screen',
    fi: 'Koko näyttö',
  },
  EXIT_FULL_SCREEN: {
    en: 'Exit full screen',
    fi: 'Poistu koko näytön tilasta',
  },
  LAYERS: {
    en: 'Layers',
    fi: 'Tasot',
  },
  LOADING: {
    en: 'Loading',
    fi: 'Ladataan',
  },
  ZOOM: {
    en: 'Zoom',
    fi: 'Zoomaa',
  },
  ZOOM_IN: {
    en: 'Zoom in',
    fi: 'Lähennä',
  },
  ZOOM_OUT: {
    en: 'Zoom out',
    fi: 'Loitonna',
  },
};
